import React, { forwardRef } from 'react';
import { clsx } from '@mentimeter/ragnar-tailwind-config';
import { Box, type BoxT } from '../box/tw';

export const PopoverBody = forwardRef<HTMLDivElement, BoxT>(
  ({ className, ...rest }, ref) => (
    <Box
      ref={ref}
      className={clsx(
        'w-full flex-auto px-4 py-2 my-2 overflow-auto',
        className,
      )}
      {...rest}
    />
  ),
);
